import ViewColumnIcon from '@mui/icons-material/ViewColumn';
import { Button, Checkbox, Divider, ListItemIcon, ListItemText, Menu, MenuItem } from '@mui/material';
import { useState } from 'react';
import {
  geldigeKolommen,
  kandidaatEigenschappen,
  type Sorteerveld,
  standaardKolommen,
  vasteKolom,
} from './kandidaatEigenschappen.ts';

interface Props {
  zichtbaar: readonly Sorteerveld[];
  onChange: (kolommen: Sorteerveld[]) => void;
}

/**
 * Een knop met een menu om kolommen van de kandidatenlijst aan en uit te zetten.
 * @param props De zichtbare kolommen en wat er bij een wijziging gebeurt.
 * @returns De knop met het menu.
 */
export function KolomKeuze({ zichtbaar, onChange }: Props) {
  const [anker, setAnker] = useState<HTMLElement | null>(null);
  const wissel = (sleutel: Sorteerveld) =>
    onChange(
      geldigeKolommen(
        zichtbaar.includes(sleutel) ? zichtbaar.filter((kolom) => kolom !== sleutel) : [...zichtbaar, sleutel],
      ),
    );
  return (
    <>
      <Button
        startIcon={<ViewColumnIcon />}
        onClick={(gebeurtenis) => setAnker(gebeurtenis.currentTarget)}
        aria-haspopup="menu"
        sx={{ flexShrink: 0 }}
      >
        Kolommen
      </Button>
      <Menu anchorEl={anker} open={Boolean(anker)} onClose={() => setAnker(null)}>
        {kandidaatEigenschappen.map((eigenschap) => (
          <MenuItem
            key={eigenschap.sleutel}
            dense
            disabled={eigenschap.sleutel === vasteKolom}
            onClick={() => wissel(eigenschap.sleutel)}
          >
            <ListItemIcon>
              <Checkbox
                edge="start"
                size="small"
                checked={zichtbaar.includes(eigenschap.sleutel)}
                tabIndex={-1}
                disableRipple
                slotProps={{ input: { 'aria-label': eigenschap.label } }}
              />
            </ListItemIcon>
            <ListItemText>{eigenschap.label}</ListItemText>
          </MenuItem>
        ))}
        <Divider />
        <MenuItem dense onClick={() => onChange([...standaardKolommen])}>
          <ListItemText inset>Standaardindeling</ListItemText>
        </MenuItem>
      </Menu>
    </>
  );
}
